/**
 * The prompt box's placeholder for a new chat, on Home and the chat page
 * alike. It teaches the one control that grounds an answer in the firm's own
 * documents; what to ask is the suggestions' job.
 *
 * @module components/chat/composerCopy
 */
export const NEW_CHAT_PLACEHOLDER = "Ask anything. Type @ for a policy or file";
